import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { Box } from '@mui/system';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { IDENTIFICATION_METHOD_TOOLTIPS } from '../../../../constants/IdentificationMethodConstants';

const HeaderContentTooltip = ({ header, content }) => {
  return (
    <Box>
      <Typography variant={'subtitle2'}>{header}</Typography>
      <Typography variant={'caption'}>{content}</Typography>
    </Box>
  );
};

const getIdentifiedViaInfo = category => {
  if (!category || !IDENTIFICATION_METHOD_TOOLTIPS[category]) {
    return null;
  }
  return {
    tooltip: IDENTIFICATION_METHOD_TOOLTIPS[category],
    label: IDENTIFICATION_METHOD_TOOLTIPS[category].TITLE
  };
};

export const NRIdentificationFormatter = ({ value }) => {
  const theme = useTheme();

  // Handle array of IdentifiedViaCategory enum values
  if (!value || !Array.isArray(value) || value.length === 0) {
    return null;
  }

  // Map each category to its tooltip info
  const identifiedViaItems = value
    .map(category => {
      const info = getIdentifiedViaInfo(category);
      return info ? { category, ...info } : null;
    })
    .filter(item => item !== null); // Only include items with valid tooltips

  if (identifiedViaItems.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: theme.spacing(0.5), flexWrap: 'wrap' }}>
      {identifiedViaItems.map((item, index) => {
        const badgeContent = (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              cursor: 'default',
              borderRadius: theme.spacing(0.5),
              border: `1px solid ${theme.palette.divider}`,
              alignItems: 'center',
              px: theme.spacing(1),
              py: theme.spacing(0.5),
              width: 'fit-content'
            }}
          >
            <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }} color={'text.secondary'}>
              {item.label}
            </Typography>
          </Box>
        );

        return (
          <Tooltip key={index} title={<HeaderContentTooltip header={item.tooltip.TITLE} content={item.tooltip.CONTENT} />}>
            {badgeContent}
          </Tooltip>
        );
      })}
    </Box>
  );
};

export const NRIdentificationProvider = props => <DataTypeProvider formatterComponent={NRIdentificationFormatter} {...props} />;
